"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _check = _interopRequireDefault(require("./check.svg"));

var makeStyle = function makeStyle()
/*{globalVariables={}}={}*/
{
  var circle = 12;
  var navBarHeight = 4;
  return {
    Stepper: {
      '& nav': {
        flex: 1,
        background: '#ddd',
        height: navBarHeight,
        width: 'calc(100% - ' + circle + 'px)',
        position: 'relative',
        top: '4px',
        margin: '0 auto'
      },
      '& nav i': {
        transition: 'all 0.3s ease-out',
        background: '#4eb5d8',
        width: '0',
        height: '100%',
        position: 'absolute',
        left: '0',
        top: '0',
        display: 'block'
      },
      '& nav .step': {
        transition: 'all 0.3s ease-out',
        position: 'absolute',
        left: '0',
        top: (circle / 2 - navBarHeight / 2) * -1 + 'px',
        width: circle + 'px',
        height: circle + 'px',
        display: 'inline-block',
        borderRadius: '100%',
        background: '#ddd',
        transform: 'translateX(-50%)',
        '& div': {
          width: '50%',
          height: '50%',
          transform: 'translateX(50%) translateY(50%)',
          borderRadius: '100%',
          background: '#fff'
        }
      },
      '& nav .step.active': {
        background: '#4eb5d8',
        '&.checked div': {
          background: 'url(' + _check["default"] + ') no-repeat center',
          width: '75%',
          height: '75%',
          transform: 'translateX(15%) translateY(15%)'
        }
      }
    }
  };
};

var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=style.js.map